import { botName, type Locale, type PlayerInfo } from '@chess-uno/shared-protocol'

/** Name shown for a player: bots are named in the reader's language. */
export function displayName(player: PlayerInfo, locale: Locale): string {
  return player.isBot && player.botLevel ? botName(player.botLevel, locale) : player.name
}
